// translations/pages/landing/fi.js

export const landingPageFI = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Paikalliset tekoälyratkaisut, joiden keskiössä on tietosuoja",
    "vision": "Tuottavuuden seuraava taso: Organisation as a Service. Tekoälytyöntekijät ottavat työn hoitaakseen ideasta tarkastettuun tulokseen.",
    "intro": "Tutkimme, kehitämme ja integroimme tekoälyn, koneoppimisen ja tietojenkäsittelyn teknologioita. Tuloksena syntyy omia tuotteita ja asiakaskohtaisia ratkaisuja, jotka analysoivat, jäsentävät, anonymisoivat ja suojaavat tietoja paikallisesti — sekä [Veridionin](veridion) avulla täysin automatisoituja tekoälytyöntekijöitä, jotka hoitavat yhdessä ihmisten kanssa kokonaisia yrityksen tehtäväalueita.",
    "detail": "Asiakkaalle asentamamme ohjelmisto toimii asiakkaan omassa infrastruktuurissa eikä tarvitse pilviyhteyttä. Dokumentit, data ja kielimallit pysyvät talon sisällä."
  },
  "partners": {
    "title": "Kumppanit, jotka luottavat meihin",
    "subtitle": "Yritykset ja tutkimuslaitokset, joissa tekoälyorganisaatiomme on tuotantokäytössä.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nKatseenseuranta- ja biosignaaliratkaisut tutkimukseenne",
        "description": [
          "BiSigma on erikoistunut biosignaalien mittaus- ja analyysijärjestelmiin sekä huipputarkkoihin katseenseurantaratkaisuihin (eye-tracking) tieteelle, kliiniseen työhön ja teolliseen tutkimukseen.",
          "pAIoneer Labs GmbH on korvannut BiSigmalla ohjelmistokehityksen kokonaan tekoälyllä, joka kehittää ja jatkokehittää menestyksekkäästi ohjelmistoja biosignaalien mittaukseen ja analysointiin."
        ],
        "cta": "Vieraile BiSigman sivuilla"
      }
    }
  },
  "products": {
    "title": "Tuotteet",
    "subtitle": "Myymme ohjelmistoja työpöytäsovelluksina työasemille, palvelinohjelmistoina asiakkaan on-premises-ympäristöön tai pilveen sekä tilauksena alustallamme, kuten [kaupankäyntiavustajaa](finance), jonka tekoälytyöntekijämme kehittävät itse. Lisäksi rakennamme tekoälyjärjestelmiä asiakkaan vaatimusten mukaan sekä tarjoamme konsultointia ja koulutusta.",
    "partnerLabel": "Kumppanituote",
    "priceOnRequest": "Hinta pyynnöstä",
    "request": "Lähetä tiedustelu",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil tunnistaa ja anonymisoi henkilötiedot Word-, Excel-, OpenDocument-, PDF- ja tekstitiedostoista, ennen kuin ne päätyvät tekoälytyökaluihin, testeihin, analyyseihin tai kolmansille osapuolille. Tunnistus yhdistää {presidio}n, {spacy}n ja {flair}in, ja se toimii saksaksi, englanniksi, ranskaksi, italiaksi ja espanjaksi.",
          "Työpöytäversio toimii itsenäisesti tavallisilla tietokoneilla, joiden käyttöjärjestelmä on Windows, macOS tai Linux, ilman GPU:ta ja ilman verkkoriippuvuutta; tiedostot eivät poistu työasemalta. API-versio toimii asiakkaan infrastruktuurissa, on-premises-asennuksena tai asiakkaan omassa pilvessä, ja se liittää anonymisoinnin osaksi olemassa olevia järjestelmiä ja työnkulkuja.",
          "Replace-tila korvaa henkilötiedot paikkamerkeillä vaatimustenmukaisuuden dokumentointia varten, Fake-tila uskottavilla korvaavilla arvoilla testiympäristöjä varten; dokumentin rakenne säilyy. AnonChatissa anonymisoitu dokumentti siirtyy ChatGPT:lle, Claudelle, Geminille tai sisäiselle kielimallille vasta esikatselun jälkeen."
        ],
        "cta": "Tutustu Kyveiliin"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Yksi luoja, loputtomasti ratkaisuja.",
        "text": [
          "pAIoneer Labs GmbH:n yritystekoäly: se ohjaa koko yritystä, kokonaisena tekoälytyöntekijöiden organisaationa, jonka liiketoimintayksiköt ulottuvat ohjelmistokehityksestä elektroniikan ja kvanttilaskennan kautta myyntiin ja hallintoon ja jota johtaa oma koordinaatiokerros.",
          "Tämä työvoima vie projektit, kirjanpidon, yrityksen tietämyksen, tiedonhaun, kehityksen ja data-analyysin itsenäisesti loppuun asti. Sen viestintä on optimoitu peliteorialla, ja kun se tarvitsee kyvyn, jota ei vielä ole, se rakentaa sitä varten oman tekoälyjärjestelmän.",
          "Se toimii omissa tiloissanne, omassa pilvessänne tai alustallamme. Siellä se kehittää [kaupankäyntiavustajan](finance) itse ja on sen chatin tekoäly."
        ],
        "points": [
          "Integroituu jokaiseen prosessiin",
          "Oppii itsenäisesti",
          "Luo puuttuvat kyvyt itse",
          "Suunniteltavissa kiinteissä sykleissä"
        ],
        "cta": "Tutustu Veridioniin"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy on yrityksille tarkoitettu tekoälypohjainen, modulaarinen agenttijärjestelmä, joka automatisoi hallinnollisia toimistotehtäviä.",
          "Viisi roolia kattaa työarjen: avustaja koordinoi tapaamisia, laatii sähköpostiluonnoksia ja hoitaa päivittäisiä tehtäviä. Valmentaja on tukena työarjen emotionaalisissa ja sosiaalisissa kysymyksissä, auttaa ristiriitatilanteissa ja tukee henkilökohtaista kehittymistä. Tietosuoja-avustaja vastaa tietosuojaa ja yksityisyyttä koskeviin asiantuntijakysymyksiin, ja sen voi kouluttaa myös muille erityisaloille, kuten paloturvallisuuteen tai vaatimustenmukaisuuteen. Koulutusvalmentaja laatii täydennyskoulutussuunnitelmia, perehdytyksiä ja koulutusmoduuleja, ja neuvonantaja analysoi ladattuja dokumentteja, tukee päätöksentekoa ja antaa strategisia suosituksia.",
          "RoBuddya isännöidään ja hallinnoidaan 100-prosenttisesti saksalaisten standardien (GDPR, BSI-Grundschutz) mukaisesti, ja sen voi liittää saumattomasti Nextcloudiin tai mihin tahansa verkkolevyyn.",
          "RoBuddy on agenttinen järjestelmä toimistotyöhön, ja sen voi yhdistää Veridioniin koko yrityksen kattavaksi yrityksen tekoälyksi: RoBuddy hoitaa työpisteen tehtävät, Veridion liittää yrityksen järjestelmät ja tiedot."
        ],
        "cta": "Tutustu RoBuddyyn",
        "vendorNote": "RoBuddy on Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen -yrityksen tuote. Tuotteen myynnistä vastaa pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "SaaS-alusta",
    "description": "Tätä sovellusta käytät tilauksena suoraan selaimessa, eikä mitään tarvitse asentaa. Se toimii omalla alustallamme, kirjautuminen edellyttää toista todennustekijää, ja kaikki tekoälykutsut kulkevat yhden keskitetyn yhteyspisteen kautta, jossa on kiinteät kiintiöt.",
    "apps": {
      "finance": {
        "name": "Tekoälypohjainen kaupankäyntiavustaja",
        "text": "Liität arvo-osuustilisi avustajaan, kysyt positioistasi omin sanoin ja näet, mitkä uutiset ovat liikuttaneet kursseja. Ennusteen laskee jokaiselle rahoitusinstrumentille oma, päivittäin uudelleen koulutettu koneoppimismalli, ja automatiikka voi käydä kauppaa signaalien perusteella. Avustajan kehittävät tekoälytyöntekijämme; chatissa he ovat myös sen tekoäly.",
        "cta": "Tutustu kaupankäyntiavustajaan"
      }
    }
  },
  "services": {
    "title": "Ydinpalvelut",
    "veridion": {
      "title": "Tekoälytyöntekijät",
      "description": "Kokonaisia työkenttiä, miehitettyinä tekoälytyöntekijöillä, jotka integroituvat yrityksen prosesseihin ja työkaluihin ja vievät työn itsenäisesti loppuun asti. Näin työskentelemme itse: pAIoneer Labs GmbH toimii sen varassa.",
      "cta": "Tutustu Veridioniin",
      "features": [
        "Organisation as a Service",
        "Tekoälytyöntekijöistä koostuvat liiketoimintayksiköt",
        "Peliteoreettisesti optimoitu viestintä",
        "On-premises tai oma pilvi"
      ]
    },
    "custom": {
      "title": "Asiakaskohtaiset tekoälyjärjestelmät",
      "description": "Kehitämme asiakkaan vaatimusten mukaan järjestelmiä datan analysointiin, käsittelyyn, jäsentämiseen, anonymisointiin ja suojaamiseen ja integroimme ne paikallisiin tai asiakkaan omiin IT-infrastruktuureihin.",
      "features": [
        "Käyttö ilman pilveä",
        "Tuotekehitys",
        "Prototyypit",
        "Tutkimus- ja kehitysprojektit"
      ]
    },
    "elektronik": {
      "title": "Elektroniikka ja laiteohjelmistot",
      "description": "Laitteistonläheinen kehitys palveluna: piirisuunnittelu ja simulointi digitaalisena kaksosena, laiteohjelmistot anturiin asti, komponenttien ja vaihtoehtojen arviointi ennen valmistusta.",
      "features": [
        "Digitaaliset kaksoset",
        "Sulautetut laiteohjelmistot",
        "Datalehtien analyysi",
        "Komponenttien arviointi"
      ]
    },
    "quantum": {
          "title": "Suvereenit LLM:t & Kvantti-AI",
          "description": "Tavoitteemme Veridionin alaisuudessa: kehittää kompakteja Made in Germany -kielimalleja, jotka tulevaisuudessa haastavat USA:n ja Kiinan suuret mallit, sekä omia kvanttitransformereita.",
          "cta": "Katso Quantum",
          "features": [
                "LLM:t Made in Germany",
                "Kvanttitransformerit",
                "Oma Quantum IDE",
                "Tekoäly kehittää tekoälyä"
          ]
    },
    "dataanalysis": {
      "title": "Data-analyysia keskustellen",
      "description": "Tekoälytyöntekijä vastaa liitetyille tietolähteille esitettyihin kysymyksiin. Se lukee tietokantojen katalogit, skeemat ja sarakkeet, esittää analyysisuunnitelman ennen kuin dataa haetaan ja selvittää monitulkintaisuudet.",
      "features": [
        "SQL-tietolähteet",
        "Korrelaatio ja regressio",
        "Taulukot ja kaaviot",
        "PDF- ja PowerPoint-vienti"
      ]
    },
    "memory": {
      "title": "Yrityksen muisti",
      "description": "Muisti dokumenttihaun sijaan: faktat, päätökset, tehtävät ja toimintatavat kytkettyinä projekteihin, henkilöihin, järjestelmiin ja dokumentteihin, joihin ne kuuluvat, mukanaan aika, jona ne pätevät. Se kasvaa itsestään keskusteluista, kokouksista ja työn tuloksista; uudempi päätös korvaa vanhemman samasta aiheesta, mitään ei katoa.",
      "features": [
        "Tietämysgraafi",
        "Faktat aikatietoineen",
        "Päätökset eivät koskaan katoa",
        "Pääsy vastuualueen mukaan"
      ]
    },
    "kyveil": {
      "title": "Paikallinen anonymisointi ilman GPU:ta",
      "description": "Kyveil anonymisoi henkilötiedot paikallisesti, joko työpöytäsovelluksena tavallisilla tietokoneilla, joiden käyttöjärjestelmä on Windows, macOS tai Linux, tai REST API:na asiakkaan infrastruktuurissa, ilman pilvipakkoa ja ilman GPU:ta.",
      "cta": "Tutustu Kyveiliin",
      "features": [
        "Anonymisointi ennen tekoälyä",
        "NLP-pohjainen PII-tunnistus",
        "Windows, macOS, Linux",
        "REST API on-premises-asennuksena"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "Tekoälyavusteinen ohjelmistokehitys tarvitsee luotettavan kontekstin. IDD kirjaa tavoitteet, ei-tavoitteet, skenaariot, agenttisäännöt ja päätökset käyttökelpoiseksi projektimuistiksi.",
      "cta": "Tutustu IDD:hen",
      "features": [
        "Agenttinen kehitys",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Skenaariot testeinä"
      ]
    },
    "finance": {
      "title": "Finanssi- ja markkina-analyysi",
      "description": "Kaupankäyntiavustajan takana on oma liiketoimintayksikkö digitaalisista työntekijöistä: tekoälydatatieteilijät ja rahoitusasiantuntijat. He arvioivat uutiset reaaliajassa, analysoivat talousuutisten tunteet ja laskevat chatissa itse markkinadatalla: korrelaatiot, regressiot, kaaviot ja omien ennusteidensa tulokset, jokainen luku suoritetusta laskentavaiheesta. Taustalla toimivat koneoppimisennuste rahoitusinstrumenttia kohden sekä automaattinen paper- ja live-kaupankäynti.",
      "cta": "Tutustu finanssitekoälyyn",
      "features": [
        "Tekoälydatatieteilijät & rahoitusasiantuntijat",
        "Uutiset reaaliajassa, tunneanalyysillä",
        "ML-ennuste rahoitusinstrumenttia kohden",
        "Automaattinen kaupankäynti"
      ]
    },
    "consulting": {
      "title": "Konsultointi",
      "description": "Konsultoimme teknisesti, organisatorisesti ja strategisesti tekoälyn käyttöönotossa, suojaamisessa ja sääntöjenmukaisessa käytössä.",
      "features": [
        "Tekoälyn hallinnointi",
        "Tiedonhallinta",
        "Tietosuoja",
        "Tietoturva"
      ]
    }
  },
  "contact": {
    "title": "Yhteystiedot",
    "addressLabel": "Osoite",
    "phoneLabel": "Puhelin",
    "emailLabel": "Sähköposti",
    "cta": "Kirjoita viesti"
  }
};
